import { EmeraldErrorModal } from 'src/common/api/emerald-error';
import { popupMessage } from '../../../messages/business-logic/popup-message';
import { EmeraldDialogTypes } from '../../enumerations/emerald-dialog-types';

export default function showPinpadDisconnectedModal() {
  return popupMessage(pinPadDisconnectModal);
}

export const pinPadDisconnectModal = new EmeraldErrorModal({
  message: 'PinPadDisconnected',
  type: EmeraldDialogTypes.Info,
  subMessage: 'PinPadPleaseConnect',
  acceptButtonLabel: 'close',
});
